export const cx = (...parts) => parts.flat().filter(Boolean).join(' ');
